import Vue from 'vue';
import isEmpty from 'lodash/isEmpty';

// Global
Vue.mixin({
  methods: {
    isEmpty(obj) {
      return isEmpty(obj);
    },
  },
});
